export const supportedCountries = ["SE", "FI", "NO"] as const;
export const DEV_COUNTRY_COOKIE_KEY = "lea_dev_country";
export const COUNTRY_SWITCH_OPTIONS = [
	{ country: "SE", label: "SE" },
	{ country: "FI", label: "FI" },
	{ country: "NO", label: "NO" },
] as const;

export type CountryCode = (typeof supportedCountries)[number];

export const normaliseCountry = (
	value: string | null | undefined
): CountryCode | undefined =>
	supportedCountries.find((country) => country === value);

/** Narrows a library `Country` (which includes ES) to a country this app serves. */
export const toCountryCode = (value: string): CountryCode => {
	const country = normaliseCountry(value);
	if (!country) {
		throw new Error(
			`Unsupported country: ${value}. Supported countries: ${supportedCountries.join(", ")}`
		);
	}
	return country;
};
